import React from 'react';

import type { CliveMood } from '~/components/Clive/cliveRegistry';
import { CLIVE_AVATARS, CLIVE_VIBERANT_BORDER } from '~/components/Clive/cliveRegistry';
import { Text } from '~/components/core';
import cn from '~/Utils/cn';

export interface CliveChipProps {
  content: string | React.ReactNode | null;
  iconPosition?: 'left' | 'right';
  iconType?: CliveMood;
  bold?: boolean;
  size?: number;
  variant?: CliveChipVariant;
}

export enum CliveChipVariant {
  DEFAULT = 'default',
  WHITE = 'white',
}

export const CliveChip: React.FC<CliveChipProps> = ({
  content,
  bold,
  iconPosition = 'left',
  iconType = 'happy',
  size = 18,
  variant = CliveChipVariant.DEFAULT,
}) => {
  const renderIcon = () => {
    if (iconType === 'none') {
      return null;
    }

    const IconComponent = CLIVE_AVATARS[iconType];

    if (!IconComponent) {
      return null;
    }

    return <IconComponent size={size + 2} className={iconPosition === 'right' ? '!relative !right-auto' : ''} />;
  };

  return (
    <div
      data-testid="ai-status-chip"
      className={cn(
        'flex w-fit items-center gap-8 rounded-full py-4 pl-8',
        content ? 'pr-16' : 'pr-8',
        'min-w-max',
        variant === CliveChipVariant.WHITE ? 'bg-white' : CLIVE_VIBERANT_BORDER
      )}
    >
      {iconPosition === 'left' && renderIcon()}
      {content ? (
        <Text variant={Text.VARIANTS.SM} weight={bold ? Text.WEIGHTS.SEMI_BOLD : Text.WEIGHTS.REGULAR}>
          {content}
        </Text>
      ) : (
        <></>
      )}
      {iconPosition === 'right' && renderIcon()}
    </div>
  );
};
